import { useNavigate } from 'react-router-dom';
import ThemeToggle from './ThemeToggle';

export default function Header() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <header className="h-16 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800 flex items-center justify-between px-6">
      <div className="flex items-center gap-4 ml-12 md:ml-0">
        <label htmlFor="search-input" className="sr-only">Search</label>
        <input
          id="search-input"
          type="text"
          placeholder="Search..."
          className="px-4 py-2 bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-white rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 w-64"
        />
        <span className="px-2 py-0.5 text-xs font-bold uppercase tracking-wide bg-yellow-400 text-yellow-900 rounded">
          Beta
        </span>
      </div>

      <div className="flex items-center gap-4">
        <ThemeToggle />

        <button
          className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg text-gray-600 dark:text-gray-300"
          aria-label="Notifications"
        >
          🔔
        </button>

        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-purple-600 rounded-full flex items-center justify-center text-white text-sm font-medium" aria-hidden="true">
            P
          </div>
          <span className="text-sm font-medium text-gray-900 dark:text-white">Phil</span>
        </div>

        <button
          onClick={handleLogout}
          className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200"
          aria-label="Logout"
        >
          Logout
        </button>
      </div>
    </header>
  );
}
